import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React from 'react';
import classNames from 'classnames';
import { useHistory } from "react-router-dom";
import { setUserRole } from '../utils/auth';
import { decodeJWT } from '../utils/jwt';

export const LoginPage = () => {

    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [submitted, setSubmitted]  = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    //const [jwt, setJwt] = 
    
    const toast = React.useRef();
    let history = useHistory();

    const showFailed = (message) => {
        toast.current.show({ severity: 'error', summary: 'Gagal', detail: message, life: 3000 });
    };

    const showError = (message) => {
        toast.current.show({ severity: 'error', summary: 'Gagal', detail: message, life: 3000 });
    };

    React.useEffect(() => {
        localStorage.removeItem("jwt");
        localStorage.removeItem("userRole");
    }, []);    

    async function clickSubmit(event) {
        event.preventDefault();
        setSubmitted(true);
        if(!username || !password) {
            showError('Username / password yang kosong')   ;
        } else {
            const requestPayload = {
                method: 'POST',
                headers: {
                    'Accept': '*',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*' 
                },
                body: JSON.stringify({
                  username: username,
                  password: password  
                })
            }
            setIsLoading(true);
            const response = await fetch('https://springboot-widy-app.widyan123.site/widy-app/users/authenticate', requestPayload);                                            
            if(response.status >= 200 && response.status <= 299) {
                const res = await response.json();
                localStorage.setItem('jwt', res.token);
                
                const payload = decodeJWT(res.token);
                const role = payload?.roles || payload?.role || res.role;
                setUserRole(role);
                
                window.location.href = '/';
            } else if(response.status >= 400 && response.status <= 499) {
                if(response.status === 401) {
                    showFailed("Username and Password Invalid!");
                    setSubmitted(false);
                } else {
                    const res = await response.json();
                    showFailed(res.message);
                    setSubmitted(false);
                }                
            } else {
                showError(`${response.status} Server Error!`);
                setSubmitted(false);
            }
            setIsLoading(false);
        }        
    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">                    
                <Toast ref={toast} />
                    <h5>Login</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                </div>
                <div className='card p-fluid'>
                    
                    <form onSubmit={clickSubmit}>
                        <div className="field">
                            <label htmlFor="username">Username</label>
                            <InputText id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} className={classNames({ 'p-invalid': submitted && !username })} />
                            {submitted && !username && <small className="p-error">Enter your username</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="password">Password</label>
                            <InputText id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={classNames({ 'p-invalid': submitted && !password })} />
                            {submitted && !password && <small className="p-error">Enter your password</small>}
                        </div>
                        <Button label="Submit" className="p-button-success mr-2" loading={isLoading} />
                    </form>
                </div>  
            </div>
        </div>
    );

// Solution to catch timeout http
//     https://chatgpt.com/c/679e28fa-521c-8009-a65f-8c888ac80d35

//     try {
//         setIsLoading(true);
    
//         const response = await fetch('http://147.93.111.86:8082/widy-app/users/authenticate', requestPayload);
    
//         // Check if response is OK (HTTP status 200-299)
//         if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//         }
    
//         const res = await response.json();
//         console.log('response', res);
    
//         localStorage.setItem('jwt', res.token);
//         history.push('/');
    
//     } catch (error) {
//         console.error("Fetch error:", error);
    
//         if (error.name === 'AbortError') {
//             showError("Request timeout! Please try again.");
//         } else {
//             showError("Network error! Please check your connection.");
//         }
        
//         setSubmitted(false);
//     } finally {
//         setIsLoading(false);
//     }

//     const controller = new AbortController();
// const timeout = setTimeout(() => controller.abort(), 5000); // 5 seconds timeout

// try {
//     setIsLoading(true);

//     const response = await fetch('http://147.93.111.86:8082/widy-app/users/authenticate', {
//         ...requestPayload,
//         signal: controller.signal, // Attach abort signal
//     });

//     clearTimeout(timeout); // Clear timeout if request completes

//     if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     const res = await response.json();
//     console.log('response', res);

//     localStorage.setItem('jwt', res.token);
//     history.push('/');

// } catch (error) {
//     console.error("Fetch error:", error);

//     if (error.name === 'AbortError') {
//         showError("Request timeout! Please try again.");
//     } else {
//         showError("Network error! Please check your connection.");
//     }

//     setSubmitted(false);
// } finally {
//     setIsLoading(false);
// }

}
